<template>
  <v-app>
    <Header v-if="!alternative" />

    <Loading v-if="loading" />
    <template v-else>
      <slot />
    </template>

    <Footer v-if="!alternative" />
    <FixedApps v-if="!alternative" />
    <CookieBanner />
  </v-app>
</template>

<script>
import Loading from "../widgets/Loading.vue";
import Header from "../shell/header/Index.vue";
import Footer from "../shell/Footer.vue";
import FixedApps from "../widgets/FixedApps.vue";
import CookieBanner from "../widgets/CookieBanner.vue";

export default {
  props: {
    alternative: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Loading,
    Header,
    Footer,
    FixedApps,
    CookieBanner,
  },
};
</script>
